<ng-container *isAllowed="[ERoleAdminString.Admin, 'subsidiary.update']">
  <app-dialog
    heading="EDITAR FILIAL"
    description="Campos com * são obrigatórios. O endereço é preenchido pelo CEP."
    closeLabel="Fechar edição de filial"
    (closed)="onCancelar()"
  >
    <form class="grid grid-cols-1 md:grid-cols-3 gap-5 mt-5" [formGroup]="formEditFilial" (ngSubmit)="editFilial()">
      <div class="form-group">
        <label for="edit-subsidiary-name" class="input-label">Nome*</label>
        <input id="edit-subsidiary-name" type="text" class="form-input" formControlName="name" />
      </div>
      <div class="form-group">
        <label for="edit-subsidiary-code" class="input-label">Código da filial*</label>
        <input id="edit-subsidiary-code" type="text" class="form-input" formControlName="code" />
      </div>
      <div class="form-group">
        <label for="edit-subsidiary-document" class="input-label">CNPJ</label>
        <input
          id="edit-subsidiary-document"
          type="text"
          class="form-input"
          [class.opacity-50]="formEditFilial.get('document')?.disabled"
          formControlName="document"
          mask="00.000.000/0000-00"
        />
      </div>

      <div class="form-group" *ngIf="podeEscolherEmpresa">
        <label for="edit-subsidiary-company" class="input-label">Empresa*</label>
        <ng-select
          labelForId="edit-subsidiary-company"
          notFoundText="Nenhum item encontrado"
          [searchable]="true"
          [items]="opcoesListCompany"
          formControlName="companyId"
          bindLabel="name"
          bindValue="id"
          appendTo="body"
        >
        </ng-select>
      </div>
      <div class="form-group">
        <label for="edit-subsidiary-zip" class="input-label">CEP*</label>
        <input
          id="edit-subsidiary-zip"
          type="text"
          class="form-input"
          formControlName="zipCode"
          mask="00000-000"
          (input)="onCEPEntered($event)"
        />
        <p class="text-xss text-red-600" *ngIf="cepError">Digite um CEP válido</p>
      </div>
      <div class="form-group">
        <label for="edit-subsidiary-number" class="input-label">Número*</label>
        <input id="edit-subsidiary-number" type="text" class="form-input" formControlName="number" />
      </div>

      <div class="form-group">
        <label for="edit-subsidiary-street" class="input-label">Logradouro</label>
        <input id="edit-subsidiary-street" type="text" class="form-input opacity-50" formControlName="address" />
      </div>
      <div class="form-group">
        <label for="edit-subsidiary-complement" class="input-label">Complemento</label>
        <input id="edit-subsidiary-complement" type="text" class="form-input" formControlName="complement" />
      </div>
      <div class="form-group">
        <label for="edit-subsidiary-district" class="input-label">Bairro</label>
        <input id="edit-subsidiary-district" type="text" class="form-input opacity-50" formControlName="district" />
      </div>
      <div class="form-group">
        <label for="edit-subsidiary-city" class="input-label">Cidade</label>
        <input id="edit-subsidiary-city" type="text" class="form-input opacity-50" formControlName="city" />
      </div>
      <div class="form-group">
        <label for="edit-subsidiary-state" class="input-label">Estado</label>
        <input id="edit-subsidiary-state" type="text" class="form-input opacity-50" formControlName="state" />
      </div>

      <div class="flex justify-end md:col-span-3">
        <button type="submit" class="px-6 btn btn--secondary">Salvar alterações</button>
      </div>
    </form>
  </app-dialog>
</ng-container>
